(function () {
  window.feppoCadCurrencySuffixLoaded = true;

  function appendCadToPriceText(text) {
    if (!text || text.indexOf('$') === -1 || text.indexOf('CAD') !== -1) {
      return text;
    }

    return text.replace(/(^|[^\w])(\$\s*[0-9][0-9,]*(?:\.[0-9]{2})?)(?!\s*(?:CAD|USD|AUD|NZD|HKD)\b)/g, function (_, prefix, amount) {
      return prefix + amount.trim() + ' CAD';
    });
  }

  function isCadCurrency() {
    var path = window.location && window.location.pathname ? window.location.pathname.toLowerCase() : '';
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'CAD') ||
      path.indexOf('/en-ca') === 0 ||
      path.indexOf('/fr-ca') === 0;
  }

  function patchCadMoneyFormatter(owner, key) {
    if (!isCadCurrency() || !owner || typeof owner[key] !== 'function' || owner[key]._feppoCadSuffixPatched) {
      return;
    }

    var originalFormatter = owner[key];
    owner[key] = function () {
      return appendCadToPriceText(originalFormatter.apply(this, arguments));
    };
    owner[key]._feppoCadSuffixPatched = true;
  }

  function patchCadMoneyFormatters() {
    patchCadMoneyFormatter(window, 'formatMoney');
    if (window.Shopify) {
      patchCadMoneyFormatter(window.Shopify, 'formatMoney');
    }
  }

  var skippedSelector = 'script, style, noscript, template, textarea, input, select, option';

  function shouldSkipElement(element) {
    return element && element.nodeType === Node.ELEMENT_NODE &&
      element.matches && element.matches(skippedSelector);
  }

  function patchTextNode(node) {
    if (!isCadCurrency() || !node || node.nodeType !== Node.TEXT_NODE || !node.nodeValue || node.nodeValue.indexOf('$') === -1) {
      return;
    }

    if (node.parentElement && node.parentElement.closest && node.parentElement.closest(skippedSelector)) {
      return;
    }

    var nextValue = appendCadToPriceText(node.nodeValue);
    if (nextValue !== node.nodeValue) {
      node.nodeValue = nextValue;
    }
  }

  function patchPriceElement(element) {
    if (!isCadCurrency() || !element || element.nodeType !== Node.ELEMENT_NODE || shouldSkipElement(element)) {
      return;
    }

    var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || node.nodeValue.indexOf('$') === -1) {
          return NodeFilter.FILTER_REJECT;
        }
        if (node.parentElement && node.parentElement.closest && node.parentElement.closest(skippedSelector)) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var nodes = [];
    var currentNode;
    while ((currentNode = walker.nextNode())) {
      nodes.push(currentNode);
    }

    nodes.forEach(patchTextNode);
  }

  function patchExistingPriceElements(root) {
    if (!isCadCurrency()) {
      return;
    }

    var selectors = [
      'product-bundle-builder .current-price',
      'product-bundle-builder .compare-price',
      'product-bundle-builder .bundle-total-price',
      'product-bundle-builder .bundle-original-price',
      'product-bundle-builder .bundle-total-price-mobile',
      'product-bundle-builder .total-price',
      'product-bundle-builder .total-compare-price',
      '.bundle-product-price',
      '.bundle-stack-price',
      '.bundle-total-price',
      '.bundle-original-price',
      '.bundle-total-price-mobile',
      '.total-price',
      '.total-compare-price',
      '.current-price',
      '.compare-price',
      '.product-card-carousel .price-sale',
      '.product-card-carousel .price-compare',
      '.product-card-carousel .price-regular',
      '.xm-current-price',
      '.xm-compare-price',
      '.xm-btn-price',
      '.xm-btn-final-price'
    ];

    var selector = selectors.join(',');
    var scope = root || document;
    var elements = [];

    if (scope.nodeType === Node.ELEMENT_NODE && scope.matches && scope.matches(selector)) {
      elements.push(scope);
    }

    if (scope.querySelectorAll) {
      Array.prototype.push.apply(elements, scope.querySelectorAll(selector));
    }

    elements.forEach(patchPriceElement);
  }

  function observePriceElements() {
    if (!isCadCurrency() || !window.MutationObserver || observePriceElements._started) {
      return;
    }

    observePriceElements._started = true;
    var isPatching = false;
    new MutationObserver(function (mutations) {
      if (isPatching || !isCadCurrency()) {
        return;
      }

      isPatching = true;
      try {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'childList') {
            Array.prototype.forEach.call(mutation.addedNodes, function (node) {
              if (node.nodeType === Node.TEXT_NODE) {
                patchTextNode(node);
              } else if (node.nodeType === Node.ELEMENT_NODE && !shouldSkipElement(node)) {
                patchExistingPriceElements(node);
              }
            });
          } else if (mutation.type === 'characterData') {
            patchTextNode(mutation.target);
          }
        });
      } finally {
        isPatching = false;
      }
    }).observe(document.documentElement, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  patchCadMoneyFormatters();
  document.addEventListener('DOMContentLoaded', function () {
    patchCadMoneyFormatters();
    patchExistingPriceElements(document);
    observePriceElements();
  });
  window.addEventListener('load', function () {
    patchCadMoneyFormatters();
    patchExistingPriceElements(document);
    observePriceElements();
  });
})();
